import { WifiOff } from "lucide-react";
import { useOnline } from "./online";

/** Faixa enquanto o aparelho está sem rede: o que já está na tela fica, mas pode estar desatualizado (itens 12 e 15). */
export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <p
      role="status"
      className="m-0 mb-4 flex items-center gap-2 rounded-control bg-warning-soft px-3 py-2 text-sm text-warning"
    >
      <WifiOff aria-hidden="true" className="size-4 shrink-0" />
      Sem conexão com a internet. O que está na tela pode estar desatualizado.
    </p>
  );
}
